import Tooltip from "react-simple-tooltip"
import './DynamicPrice.scoped.scss'
import formatCurrency from 'Shared/functions/formatCurrency'

export default function DynamicPrice({ usdAmount, textClasses }) {
  if (usdAmount === 'NaN') return null

  var amountDisplayCurrency, tooltipContent, currencySymbol;

  if (window.ENV.DISPLAY_CURRENCY === 'GBP') {
    currencySymbol = '£'
    amountDisplayCurrency = window.ENV.USD_GBP_EXCHANGE * usdAmount
    tooltipContent = `Estimated amount $${formatCurrency(usdAmount || 0)} based on latest exchange rate of ${window.ENV.USD_GBP_EXCHANGE} pounds to the dollar`
  } else if (window.ENV.DISPLAY_CURRENCY === 'USD') {
    currencySymbol = '$'
    amountDisplayCurrency = usdAmount
    tooltipContent = `Estimated amount $${formatCurrency(usdAmount || 0)}`
   } else  {
    currencySymbol = '$'
    amountDisplayCurrency = usdAmount
    tooltipContent = `Estimated amount $${formatCurrency(usdAmount || 0)}`
   }

  return <Tooltip
    content={tooltipContent || ''}
    style={{whiteSpace: "nowrap"}}
    open={true}
    >
    <span className={`root ${textClasses}`}>~{currencySymbol}{formatCurrency(amountDisplayCurrency)}</span>
  </Tooltip>
}
